/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthPlatformRemotePatientSearchPayload
 */
export interface AuthPlatformRemotePatientSearchPayload {
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    dob?: string;
    /**
     * 
     */
    member_number?: string;
}

/**
 * Check if a given object implements the AuthPlatformRemotePatientSearchPayload interface.
 */
export function instanceOfAuthPlatformRemotePatientSearchPayload(value: object): value is AuthPlatformRemotePatientSearchPayload {
    return true;
}

export function AuthPlatformRemotePatientSearchPayloadFromJSON(json: any): AuthPlatformRemotePatientSearchPayload {
    return AuthPlatformRemotePatientSearchPayloadFromJSONTyped(json, false);
}

export function AuthPlatformRemotePatientSearchPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthPlatformRemotePatientSearchPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'dob': json['dob'] == null ? undefined : json['dob'],
        'member_number': json['member_number'] == null ? undefined : json['member_number'],
    };
}

export function AuthPlatformRemotePatientSearchPayloadToJSON(json: any): AuthPlatformRemotePatientSearchPayload {
    return AuthPlatformRemotePatientSearchPayloadToJSONTyped(json, false);
}

export function AuthPlatformRemotePatientSearchPayloadToJSONTyped(value?: AuthPlatformRemotePatientSearchPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'dob': value['dob'],
        'member_number': value['member_number'],
    };
}

